import React, {Component} from 'react'
import {Dropdown} from 'semantic-ui-react';
import {getCompanyCollection} from '../firebase';

class Lista extends Component{
	constructor(props){
		super(props);
		this.filtro1=this.props.filtro1
		this.filtro2=this.props.filtro2
		this.filtro3=this.props.filtro3
        this.database = null
		this.state = {
			options: [],
		}
	}
	setReference=()=>{
        let dbReference=this.database
        dbReference=this.addFilter(dbReference)
        return dbReference
    }
	addFilter=dbReference=>{
        if(!this.filtro1 || !this.filtro2 || !this.filtro3) return dbReference
        return dbReference.where(this.filtro1, this.filtro2, this.filtro3)
    }
    childAdded=(querySnapshot)=>{
        const docs = []
		if(this.props.extraoptions){
			for(let i in this.props.extraoptions){
				docs.push(this.props.extraoptions[i])
			}
		}
        querySnapshot.forEach(doc=>{
            docs.push({key:doc.id, value:doc.data()[this.props.columna], text:doc.data()[this.props.columna]})
        })
		this.setState({options: docs})
	}
	async componentDidMount(){
		this.database = await getCompanyCollection(this.props.tabla)
		this.unsubscribe = this.setReference().onSnapshot(this.childAdded)
	}
	componentWillUnmount(){ if (this.unsubscribe) this.unsubscribe() }

	render(){
		return (
		<div className='SelectContainer'>
			<Dropdown 
				fluid
				multiple
				selection
				options={this.state.options}
				{...this.props}
			/>
		</div>
		)
	}
}

export default Lista;
